import { createContext, use } from 'react'
import type { Operator } from './types'

export interface PlatformAuthValue {
  status: 'loading' | 'authenticated' | 'anonymous'
  operator: Operator | null
  login: (email: string, password: string) => Promise<void>
  logout: () => Promise<void>
}

export const PlatformAuthContext = createContext<PlatformAuthValue | null>(null)

export function usePlatformAuth(): PlatformAuthValue {
  const value = use(PlatformAuthContext)
  if (!value) throw new Error('usePlatformAuth must be used inside <PlatformAuthProvider>')
  return value
}
